import React, { Component } from 'react';

export default class CustomErrorPage extends Component {
    render() {
        return(
            <div>
                <div style={{display:"flex", justifyContent:"flex-start", marginBottom:"20px"}}>
                    {this.props.brandLogo}
                </div>                
                <h3>{this.props.errorMsg}</h3>
                <p></p>
                <p>Please contact Watermark Medical for support at 1-866-875-9765.</p>
            </div>
        );
    }
}